// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xxsmallOnConfined-superElipse-38af8d56","strokeWidth":"super-ellipse-skins-xxsmallOnConfined-strokeWidth-6de9368b"};